import React, { useState, useEffect } from 'react';
import Navbar from './global-components/navbar-v2';
import Footer from './global-components/footer-v2';
import Scrollp from './Scroll-Parallax/scrollp';
import FormulaireInscrit from './global-components/formulaire-inscrit';
import { Link } from 'react-router-dom';
import FormulaireInscriptionEnLigne from './global-components/formulaire-inscritenligne'; // Import du formulaire

const Inscription = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isSuccessMessageVisible, setIsSuccessMessageVisible] = useState(false);

  const handleOpenPopup = () => {
    setIsPopupVisible(true);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };
  return (
    <div>
      <Navbar />
      <FormulaireInscrit />

      {/* Success Popup */}
      {isSuccessMessageVisible && (
        <div className="popup-overlay">
          <div className="popup-content text-center">
            <h4>Inscription réussie !</h4>
            <button
              className="popup-close-button"
              onClick={() => setIsSuccessMessageVisible(false)}
            >
              ✕
            </button>
          </div>
        </div>
      )}

      {/* Form Popup */}
      {isPopupVisible && (
        <div className="popup-overlay ">
          <div className="popup-content ">
            {/* Formulaire d&apos;inscription */}
            <FormulaireInscriptionEnLigne
              onSuccess={() => {
                setIsPopupVisible(false);
                setIsSuccessMessageVisible(true);
              }}
            />
            <button onClick={handleClosePopup} className="popup-close-button">
              ✕
            </button>
          </div>
        </div>
      )}

      <Footer />
      <Scrollp />
      <div className="fixed-buttons">
        <Link to="/Formateur">
          <button className="btn btn-primary">Devenir formateur</button>
        </Link>
        <Link to="/inscriptionenligne">
          <button className="btn btn-secondary">Inscription en ligne</button>
        </Link>
      </div>
    </div>
  );
};
export default Inscription;
